<template>
  <div class="forgot p-5">
    <div class="text-center mb-5">
      <h3 class="text-black-50 font-weight-bold mb-4">Reset your password</h3>

      <span class="text-black-50 font-weight-bolder">
        Enter your email address and we'll send you instructions on how to reset
        your password
      </span>
    </div>

    <div class="login-form">
      <validation-observer ref="observer">
        <div
          class="alert fade text-center font-weight-bolder"
          :class="{
            show: success || error,
            'alert-light-danger': error,
            'alert-light-success': success,
          }"
          v-html="success || error || '&nbsp;'"
          v-if="success || error"
        ></div>

        <b-form-group
          label="Email"
          label-for="email"
          label-class="font-weight-bolder"
        >
          <validation-provider
            name="email"
            rules="required|email"
            v-slot="{ errors }"
          >
            <b-form-input
              placeholder="Your email address"
              :disabled="loading"
              v-model="form.email"
            />
            <b-form-text
              text-variant="danger"
              class="font-weight-bold"
              v-if="errors[0]"
              >{{ errors[0] }}</b-form-text
            >
          </validation-provider>
        </b-form-group>

        <div class="text-center mt-12">
          <button
            class="btn btn-dark rounded-pill font-weight-bolder w-100 mb-5"
            :disabled="loading"
            :class="{
              'spinner spinner-success spinner-lg spinner-left': loading,
            }"
            @click.stop="submit"
          >
            <span v-if="loading">Sending...</span>
            <span v-else>Send Instructions</span>
          </button>
          <button
            class="btn btn-secondary rounded-pill font-weight-bolder w-100"
            :disabled="loading"
            @click="$router.push('login')"
          >
            Back to login page
          </button>
        </div>
      </validation-observer>
    </div>
  </div>
</template>

<script>
import {
  ValidationObserver,
  ValidationProvider,
} from "vee-validate/dist/vee-validate.full";

import AuthService from "@/services/auth.service";
import { formatErrorMessage } from "@/utils/random_utils";

export default {
  name: "ForgotPassword",
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  methods: {
    async submit() {
      const valid = await this.$refs.observer.validate();

      if (!valid) return;

      const payload = {
        email: this.form.email,
      };

      this.error = null;
      this.success = null;
      this.loading = true;

      AuthService.forgotPassword(payload)
        .then(({ data }) => {
          this.success = `Email sent to ${payload.email}`;
          this.reset();
          setTimeout(() => {
            this.$router.push({ name: "login" });
          }, 5000);
        })
        .catch(({ message }) => {
          this.error = formatErrorMessage(message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    reset() {
      if (this.$refs.observer) this.$refs.observer.reset();

      this.form = {
        email: null,
      };
    },
  },
  data() {
    return {
      error: null,
      success: null,
      loading: false,
      form: {
        email: null,
      },
    };
  },
};
</script>
